<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="设备编号：" prop="code">
                <el-input v-model="model.code"></el-input>
            </el-form-item>
            <el-form-item label="名称：" prop="name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="简称：" prop="alias">
                <el-input v-model="model.alias"></el-input>
            </el-form-item>
            <el-form-item label="型号：" prop="model">
                <el-input v-model="model.model"></el-input>
            </el-form-item>         
            <el-form-item label="生产厂家：" prop="company_produce">
                <el-select v-model="model.company_produce" placeholder="请选择" clearable filterable style="width: 100%">
                    <el-option v-for="item in producerList" :key="item.id"  :label="item.name" :value="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出厂编号：" prop="factory_code">
                <el-input v-model="model.factory_code" style="width: 300px"></el-input>
            </el-form-item>
            <el-form-item label="使用单位：" prop="company_use">
                <el-input v-model="model.company_use"></el-input>
            </el-form-item>
            <el-form-item label="所在位置：" prop="location">
                <el-input v-model="model.location"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index" style="width: 150px"></el-input>
            </el-form-item>
            <el-form-item label="设备状态：" prop="device_state">
                <el-select clearable v-model="model.device_state" placeholder="请选择" style="width: 150px">
                    <el-option v-for="item in enuObj('device_state')" :key="'device_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="路由器：" prop="router_id">
                <el-select v-model="model.router_id" placeholder="请选择" clearable filterable style="width: 300px">
                    <el-option v-for="item in routersList" :key="item.id"  :label="item.factory_code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'
import { getRoutersList, getAllProducerList } from '@/api/deviceuser'

export default {
    name: 'deviceCheckEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                code: '',
                name: '',
                alias: '',
                model: '',
                time_difference: '',
                company_produce: '',
                company_use: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
                flow_threshold: 40,
                pressure_threshold: 3,
                lift_threshold: 100,
                work_time_type: '1',
                work_time_start: '',
                work_time_end: '',
            },
            getObj:{
                url:'/api/admin/devicecheck/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_state'],
            rules: {
                code: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                name: [
                    {required: true, message: '名称不能为空', trigger: 'blur'}
                ],
                alias: [
                    {required: true, message: '简称不能为空', trigger: 'blur'}
                ],
                model: [
                    {required: true, message: '型号不能为空', trigger: 'blur'}
                ],
                device_state: [
                    {required: true, message: '设备状态不能为空', trigger: 'blur'},
                ],
                factory_code: [
                    {required: true, message: '出厂编号不能为空', trigger: 'blur'},
                ],
            },
            checkObj:{
                url:'/api/admin/devicecheck/check',
                data:{}
            },
            exits_p_name:'code',
            exits_p_title:'设备编号',
            routersList: [],
            producerList: [],
        };
    },
    methods: {
        loadOtherData() {
            getRoutersList().then(res=>{
                if(res.code ==1){
                    this.routersList = res.data
                }
            })
            getAllProducerList().then(res=>{
                if(res.code ==1){
                    this.producerList = res.data
                }
            })
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/devicecheck/saveRelationDevice'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-close",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.device_state = this.model.device_state+""
        },
    }
};
</script>